"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAdvtState = void 0;
function setAdvtState(key, value) {
    var _a;
    if (typeof window !== 'undefined') {
        window.ADVT = __assign(__assign({}, (window.ADVT || {})), (_a = {}, _a[key] = value, _a));
    }
}
exports.setAdvtState = setAdvtState;
